module.exports = __webpack_public_path__ + "0d9c2b1bcfe73f3716d6eb1a19b725b5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/book.png
// module id = 1809
// module chunks = 0